import type { ContratData, Structure } from './content';
import { renderContratHTML } from './renderContratHTML';
import { exportHtmlToPdf, renderHtmlsToPdfBlob } from '../utils/pdfExport';
import { openHtmlPreview } from '../utils/openDocument';

/**
 * Génération PDF — capture section par section.
 * Important : on ne capture jamais tout le contrat dans un seul canvas, car
 * les longs documents dépassent vite la taille maximale d'un canvas navigateur
 * et finissent tronqués/coupés dans le PDF.
 */
export async function genererContratPdf(
  structure: Structure,
  data: ContratData,
  fileName: string,
): Promise<void> {
  const html = renderContratHTML(structure, data);
  await exportHtmlToPdf(html, { fileName, rootId: '__contrat_pdf_root' });
}

/** Génère le PDF du contrat et le renvoie en Blob (pour upload / envoi). */
export async function genererContratPdfBlob(
  structure: Structure,
  data: ContratData,
  fileName: string,
): Promise<Blob> {
  const html = renderContratHTML(structure, data);
  return renderHtmlsToPdfBlob([html], { fileName, rootId: '__contrat_pdf_blob_root' });
}


/** Aperçu HTML du contrat dans la visionneuse intégrée. */
export function previewContratHtml(structure: Structure, data: ContratData): void {
  const html = renderContratHTML(structure, data);
  const ref = (data as any)?.devis_numero || (data as any)?.client_nom || '';
  if (!openHtmlPreview(html, ref ? `Contrat client — ${ref}` : 'Contrat client')) {
    throw new Error("Impossible d'afficher l'aperçu.");
  }
}
